import React from "react";
import { Checkbox } from "semantic-ui-react";

function FormCheckBox({ label, descricao, valor, onChange, mobile }) {
    const handleChange = (e, data) => {
        onChange(valor, data.checked); // envia o valor e se está marcado ou não
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '24px' }}>
            <Checkbox
                label={
                    <label style={{ fontSize: mobile ? '14px' : '18px' }}>
                        <strong style={{ marginRight: '20px' }}>{label}</strong>
                        {valor !== null && valor !== undefined && (
                            <strong>
                                {new Intl.NumberFormat('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                }).format(valor)}
                            </strong>
                        )}
                    </label>
                }
                onChange={handleChange}
            />
            {descricao && (
                <span style={{ fontSize: '12px' }}>({descricao})</span>
            )}
        </div>
    );
}

export default FormCheckBox;
